import React, { useEffect, useState, createContext, useCallback, useContext } from "react";

export const BreadcrumbContext = createContext();

const BreadcrumbProvider = ({ children }) => {
  const [currentBreadcrumb, setCurrentBreadcrumb] = useState();
  const [contextValue, setContextValue] = useState({
    breadcrumb: undefined,
    setBreadcrumb: () => {}
  });

  const setBreadcrumb = useCallback(breadcrumb => {
    setCurrentBreadcrumb(breadcrumb);
  }, []);

  useEffect(() => {
    let title = "";
    if (currentBreadcrumb) {
      title = currentBreadcrumb.reduce(
        (title, { label, current }) =>
          current && label ? `${label} - ` : title,
        ""
      );
    }
    document.title = `${title}Clickideia`;

    setContextValue({
      breadcrumb: currentBreadcrumb,
      setBreadcrumb: setBreadcrumb
    });
  }, [currentBreadcrumb, setBreadcrumb]);
  return (
    <BreadcrumbContext.Provider value={contextValue}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

/**
 * 
 * @returns {{ breadcrumb?: {label: string, url: string, current: boolean}, setBreadcrumb: (breadcrumbs: {label: string, url: string, current?: boolean}[]) => void }} BreadcrumbContext
 */
export function useBreadcrumb() {
  const context = useContext(BreadcrumbContext);

  if (!context) throw new Error('useBreadcrumb must be used within BreadcrumbProvider');

  return context;
}

export default BreadcrumbProvider;
